import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, ICrudGetAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './business-unit.reducer';
import { IBusinessUnit } from 'app/shared/model/business-unit.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IBusinessUnitDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const BusinessUnitDetail = (props: IBusinessUnitDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { businessUnitEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          <Translate contentKey="ordersManagementApp.businessUnit.detail.title">BusinessUnit</Translate> [<b>{businessUnitEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="businessUnitName">
              <Translate contentKey="ordersManagementApp.businessUnit.businessUnitName">Business Unit Name</Translate>
            </span>
          </dt>
          <dd>{businessUnitEntity.businessUnitName}</dd>
        </dl>
        <Button tag={Link} to="/business-unit" replace color="info">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/business-unit/${businessUnitEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ businessUnit }: IRootState) => ({
  businessUnitEntity: businessUnit.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(BusinessUnitDetail);
